export default "__VITE_ASSET__D$5az7pK__"